/**
 * Usage:
 *
 * data-sw-dimension-instance-chooser=<productSpin>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-dimension-instance-chooser]').each(function() {
    var $el = $(this);

    require([
      'js/lib/models/ModelManager',
      'rrViewComponents/Product/ProductDimensionInstanceChooserComponent/ProductDimensionInstanceChooser'
      ], function(ModelManager, DimensionInstanceChooser) {

        var props = $el.swDataParams('swDimensionInstanceChooser');
        var productSpin = props.swDimensionInstanceChooserProductSpin;
        var dimensionInstanceId = props.swDimensionInstanceChooserDimensionInstanceId;
        var choiceId = props.swDimensionInstanceChooserDimensionChoiceId;

        if (!productSpin) {
          return;
        }

        var product = ModelManager.getProduct(productSpin);

        new DimensionInstanceChooser({
          el: $el,
          model: product,
          dimensionInstanceId: dimensionInstanceId,
          dimensionChoiceId: choiceId
        });
    });
  });

};
